import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { v1 } from 'ember-uuid';
import SellerOnlyRouteMixin from 'sh-www/mixins/seller-only-route-mixin';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

const sellerApplicationsCache = () => {
  const cache = new Map();
  const cacheKey = v1();

  return Object.freeze({
    get cacheKey() {
      return cacheKey;
    },

    getPage(page) {
      return cache.get(page);
    },

    setPage(page, value) {
      cache.set(page, value);
      return value;
    },
  });
};

const controllers = ['submitted', 'hired'].map(x => `postings.applications.${x}`);

export const sellerApplicationsViewRouteFactory = (activeNavItem, path) => {
  return class SellerApplicationsViewRoute extends Route.extend(SellerOnlyRouteMixin) {
    @service('commands/application-commands') applicationCommandService;

    /** @inheritDoc */
    model() {
      return { };
    }

    /** @inheritDoc */
    setupController() {
      super.setupController(...arguments);

      this.controllerFor('postings.applications').set('activeNavItem', activeNavItem);

      controllers.forEach((controllerName) => {
        const controller = this.controllerFor(controllerName);
        controller.set('cache', sellerApplicationsCache());
        controller.loadApplications.perform(1);
      });
    }

    /** @inheritDoc */
    resetController(_, isExiting) {
      super.resetController(...arguments);

      if (isExiting) {
        controllers.forEach((controllerName) => {
          this.controllerFor(controllerName).loadApplications.cancelAll();
        });
      }
    }

    activate(transition) {
      super.activate(...arguments);
      trackPageViewFromTransition(this, transition, path);
    }
  };
};

class ApplicationsRoute extends Route.extend(SellerOnlyRouteMixin) {
  @service router;

  redirect() {
    return this.router.replaceWith(EMBER_ROUTE_NAMES.POSTINGS__APPLICATIONS__SUBMITTED);
  }
}

export default ApplicationsRoute;
